import { Injectable } from '@angular/core';
import { ActivatedRoute, convertToParamMap, Router } from '@angular/router';

import { FormControl } from '@ngneat/reactive-forms'
import {
  BehaviorSubject,
  map,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import {
  Filial,
  ProdutoEmbalagem,
  ProdutoResponseInAllBranches,
} from '../../../../models/product.models';
import { AmountValueService } from '../../../api/amount-value/amount-value.service';
import { Product } from '@brunsker/libs/portal-do-vendedor/ui/product-card';
import { MapperService, SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import { NewApiProductService } from '../../../api/new-api-product/new-api-product.service';
import { FormArray } from '@angular/forms';
import { hasValidPackagingFactor, packagingFactor } from '../../../../utils/product-packaging';

@Injectable({
  providedIn: 'root',
})
export class ProdutoDomainService {
  hasClient = this.selectClientService.hasClient$$;
  stockControl = new FormControl<number>(0);
  sellingValue = new FormControl(0);
  discount = new FormControl(0);
  product$!: Observable<Product>;
  productInAllBranches$!: Observable<ProdutoResponseInAllBranches[]>;
  currentIdFilial$$: ReplaySubject<number> = new ReplaySubject(1);
  currentFilial$$: BehaviorSubject<Filial> = new BehaviorSubject({
    id: 0,
    endereco: 'Nenhuma Filial Selecionada',
    estoque: 0,
    preco: 0,
  });
  currentIdFilial!: number;
  product!: Product;
  destroy$ = new Subject<boolean>();
  private currentFilialSubscription?: Subscription;

  select!: string | null;
  lastSelect!: number;
  formArray = new FormArray<FormControl<boolean>>([]);
  embalagensprod!: string[];
  embalagens: ProdutoEmbalagem[] = [];
  selectedPackaging = new FormControl<number>(0);
  readonly hasValidPackagingFactor = hasValidPackagingFactor;

  get fatorEmbalagem(): number {
    const selected = this.product?.embalagemSelecionada;
    return hasValidPackagingFactor(selected) ? packagingFactor(selected) : 0;
  }

  get embalagemValida(): boolean {
    return !this.embalagens.length ||
      (!!this.product?.embalagemSelecionada &&
        hasValidPackagingFactor(this.product.embalagemSelecionada));
  }

  constructor(
    readonly mapperService: MapperService,
    readonly newApiProductService: NewApiProductService,
    readonly amountValueService: AmountValueService,
    private readonly selectClientService: SelectClientService,
    readonly route: ActivatedRoute
    ) {}

  start(router: ActivatedRoute) {
    const id = router.snapshot.params['id'] as number;
    const selectedClient = this.selectClientService.getCliente();
    const codigoFilial =
      selectedClient?.filial ??
      (router.snapshot.params['codigoFilial'] as number);
    const query = router.snapshot.queryParams['produt'];
    this.select = query;
    this.lastSelect = 0;
    this.formArray = new FormArray<FormControl<boolean>>([]);
    this.embalagensprod = [];
    this.embalagens = [];
    this.selectedPackaging.setValue(0, { emitEvent: false });
    this.currentFilialSubscription?.unsubscribe();
    this.subStart(id ,codigoFilial);
  }

  subStart(id: number, codigoFilial: number){
    const currentClient = this.selectClientService.getCliente();

    const user = JSON.parse(sessionStorage.getItem('user') ?? '');
    this.product$ = this.newApiProductService
      .getProductById({
        Matricula: user.idFuncionario,
        CodigoProduto: id.toString(),
        CodigoFilial: codigoFilial.toString(),
        CodigoCliente: currentClient?.id.toString(),
        CodigoUsuario: currentClient?.vendedor ?? user.idVendedor,
        CodigoPlanoPagamento: currentClient?.planoDePagamento,
        CodigoCobranca: currentClient?.formaDePagamento,
        Embalagem: this.select,
        OrigemPedido: currentClient?.origemVenda,
      })
      .pipe(
        map((produto) => {
          const hasPrice = +produto.preco;
          const taxa = hasPrice * this.amountValueService.AMOUNT_VALUE;
          const newPrice =
            produto.descontoMaximoResponse.descautomatico === 'S'
              ? +produto.preco +
                taxa -
                (+produto.preco * produto.descontoMaximoResponse.percdesc) / 100
              : +produto.preco + taxa;
          const remappedProduct = {
            id: produto.sku,
            detalhe: produto.detalhE_PRODUTO,
            name: produto.titlE_PRODUTO,
            image: produto.images[0]?.urL_IMG,
            images: produto.images,
            stock: +produto.qT_DISPONIVEL,
            newPrice: newPrice,
            olderPrice: +produto.preco,
            descontoMaximo: produto.descontoMaximoResponse,
            qtd: 1,
            embalagem: produto.embalagem,
            filial: produto.iD_FILIAL,
            multiplo: produto.multiplo,
            embalagensprod: produto.embalagensprod ?? [],
            embalagens: produto.embalagens ?? [],
            unidade: produto.unidademaster,
            precound: produto.precound,
            pLANCAMENTO: produto.pLANCAMENTO,
            pNOVOEST: produto.pNOVOEST,
            pPRECOPROM: produto.pPRECOPROM,
            pDESCONTO: produto.pDESCONTO,
          } as Product;
          this.embalagensprod = produto.embalagensprod ?? [];
          this.embalagens = produto.embalagens ?? [];

          if(!this.embalagens.length && this.formArray.length == 0 && produto.embalagensprod){
            let cont = 0;
            produto.embalagensprod.forEach((value, index)=>{
              if(index == 0 && !this.select ) this.select = value;
              
              const valid = !this.select ? 
              (index == 0 ? true : false) : 
              this.select === value && cont === 0 ? true : false;

              this.formArray.push(new FormControl(valid));
              
              if(valid)
              {
                cont++;
                this.lastSelect = index;
              }
            })
          }

          this.product = remappedProduct;
          this.sellingValue.setValue(parseFloat(remappedProduct.newPrice.toFixed(2)))
          const initialDiscount = remappedProduct.olderPrice
            ? (remappedProduct.newPrice / remappedProduct.olderPrice - 1) * 100
            : 0;
          this.discount.setValue(Number(initialDiscount.toFixed(this.embalagens.length ? 7 : 2)));
          if (this.embalagens.length) {
            const selectedIndex = this.embalagens.findIndex((embalagem) =>
              hasValidPackagingFactor(embalagem) &&
              (embalagem.nomeEmbalagem === this.select ||
                embalagem.unidadeDeVenda === this.select || embalagem.ean === this.select)
            );
            const firstValid = this.embalagens.findIndex(hasValidPackagingFactor);
            this.selectPackaging(selectedIndex >= 0 ? selectedIndex : Math.max(firstValid, 0));
          }
          return remappedProduct;
        })
      );

    if(this.formArray.length == 0){
      this.productInAllBranches$ = this.newApiProductService
        .getProductInAllBranches({
          prod: id,
        })
        .pipe(
          map((branches) => {
            return branches;
          })
        );

      this.currentIdFilial$$.next(currentClient?.filial || codigoFilial);

      this.currentFilialSubscription = this.currentIdFilial$$
        .pipe(takeUntil(this.destroy$))
        .subscribe((idFilial) => {
          this.currentFilial(idFilial);
          this.currentIdFilial = idFilial;
          history.replaceState({}, '', `produtos/produto/${id}/${idFilial}`);
        });
    }
  }

  selectPackaging(index: number) {
    const embalagem = this.embalagens[index];
    if (!embalagem) return;

    const previousFactor = this.fatorEmbalagem;
    const unitSellingValue = this.product.embalagemSelecionada && previousFactor > 0
      ? this.sellingValue.value / previousFactor
      : this.product.newPrice;
    this.selectedPackaging.setValue(index, { emitEvent: false });
    this.product.embalagemSelecionada = embalagem;
    this.product.embalagem = embalagem.nomeEmbalagem;
    this.product.unidade = embalagem.unidadeDeVenda;
    this.sellingValue.setValue(Number((unitSellingValue * this.fatorEmbalagem).toFixed(7)));
  }

  selectEmbala(index: number){
    this.select = this.embalagensprod[index];
    let thisChang = index;
    this.formArray.controls.forEach((form, i)=>{
      if (index != i){
        form.setValue(false, {emitEvent:false});
      }
      else{
        form.setValue(true, {emitEvent:false});
      }
    });
    if(thisChang == this.lastSelect) return;
    this.lastSelect = thisChang;


    this.subStart(this.product.id ,this.product.filial);;
  }

  currentFilial(id: number) {
    const currentFilial = this.productInAllBranches$.pipe(
      map((branches) => {
        const branch = branches.find((branch) => branch.id_filial == id);

        if (!branch) return;

        const taxa = +branch.preco * this.amountValueService.AMOUNT_VALUE;

        const filial = {
          id: branch.id_filial,
          endereco: branch.endereco,
          estoque: branch.qtdisponivel,
          preco: +branch.preco + taxa,
        };

        return filial;
      })
    );
    currentFilial.subscribe((filial) => {
      if (!filial) {
        return;
      }
      this.currentFilial$$.next(filial);
    });
  }
}
